<template>
    <v-container>
        <v-card>
            <v-card-title>
                {{text.appTitle}}-{{text.administrator.title}}
            </v-card-title>
            <v-card-text>
                <v-tabs>
                    <v-tab href="#config">{{text.administrator.tabConfig}}</v-tab>
                    <v-tab href="#users">{{text.administrator.tabUsers}}</v-tab>
                    <v-tab href="#events" @click="getEcEvent">{{text.reportView}}</v-tab>
                    <v-tab href="#training">{{text.administrator.traning}}</v-tab>
                    <v-tab href="#messege" @click="getEcMesTemplate">{{text.sendMessege}}</v-tab>

                    <v-tab-item value="config">
                        <v-expansion-panels focusable popout>
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{text.administrator.conifg.dep.title}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    {{text.administrator.conifg.dep.detail}}<br>
                                    <v-select chips deletable-chips multiple :items="exclusionDep.selectList" v-model="exclusionDep.configData">
                                    </v-select>
                                    <v-btn @click="updateEcConfigDep" :disabled="disUpdateBtn">{{text.update}}</v-btn>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{text.administrator.conifg.adminuser.title}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-subheader>{{text.administrator.conifg.adminuser.text}}</v-subheader>
                                    <v-card>
                                        <v-card-title>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="3">
                                                        <v-text-field :label="text.administrator.listColumn.userId" v-model="addUserId"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="2">
                                                        <v-btn @click="addAdminUser">{{text.administrator.conifg.adminuser.addBtn}}</v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-simple-table dense>
                                                <thead>
                                                    <tr>
                                                        <th>{{text.administrator.conifg.adminuser.listColumn.userid}}</th>
                                                        <th>{{text.administrator.conifg.adminuser.listColumn.name}}</th>
                                                        <th>{{text.administrator.conifg.adminuser.listColumn.remove}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="user in adminUsers" :key="user.userid">
                                                        <th>{{user.userid}}</th>
                                                        <th>{{user.name}}</th>
                                                        <th><v-btn @click="removeUser(user.userid)">{{text.administrator.conifg.adminuser.listColumn.remove}}</v-btn></th>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{text.administrator.conifg.adminCheckTime.title}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-subheader>{{text.administrator.conifg.adminCheckTime.text}}</v-subheader>
                                    <v-text-field v-model="ecConfig.trigerTime" :suffix="text.minutes" style="max-width:5em"></v-text-field>
                                    <v-btn @click="updateEcConfigTime">{{text.update}}</v-btn>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{text.administrator.conifg.alertCondition.title}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-subheader>{{text.administrator.conifg.alertCondition.text}}</v-subheader>
                                    <v-expansion-panels>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>{{text.earthquake}}</v-expansion-panel-header>
                                            <v-subheader><v-btn @click="addConsitItem()">{{text.add}}</v-btn></v-subheader>
                                            <v-simple-table>
                                                <thead>
                                                    <tr>
                                                        <th>{{text.administrator.conditLolumn.area}}</th>
                                                        <th>{{text.administrator.conditLolumn.maxInt}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <v-menu absolute close-on-click v-for="conditData in ecCondits.quake" :key="conditData.areaName">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <tr  v-bind="attrs" v-on="on">
                                                            <th>{{conditData.areaCode}}:{{conditData.areaName}}</th>
                                                            <th>{{conditData.maxIntStr}}</th>
                                                            </tr>
                                                        </template>
                                                        <v-list>
                                                            <v-list-item @click="updateEcConfigCondtItem(1,conditData.areaCode)">{{text.remove}}</v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </tbody>
                                            </v-simple-table>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel><!--送信メッセージ設定-->
                                <v-expansion-panel-header>{{text.administrator.conifg.msessege.root}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-text-field outlined :label="text.administrator.conifg.msessege.subject" v-model="messegeTemplete.subject"></v-text-field>
                                    <v-textarea outlined :label="text.administrator.conifg.msessege.precall" v-model="messegeTemplete.precall"></v-textarea>
                                    <v-textarea outlined :label="text.administrator.conifg.msessege.call" v-model="messegeTemplete.call"></v-textarea>
                                    <v-textarea outlined :label="text.administrator.conifg.msessege.callProxy" v-model="messegeTemplete.callProxy"></v-textarea>
                                    <v-btn @click="updateEcConfigMessege">{{text.update}}</v-btn>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel><!--確認項目設定-->
                                <v-expansion-panel-header>{{text.administrator.conifg.reportColumn.root}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-simple-table>
                                        <thead>
                                            <tr>
                                                <th>{{text.administrator.conifg.reportColumn.title}}</th>
                                                <th>{{text.administrator.conifg.reportColumn.required}}</th>
                                                <th>{{text.administrator.conifg.reportColumn.type}}</th>
                                                <th>{{text.administrator.conifg.reportColumn.selectItem}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="clmn of reportColumnTemplete" :key="clmn.value">
                                                <th><v-text-field  outlined v-model="clmn.title"></v-text-field></th>
                                                <th><v-checkbox v-model="clmn.required"></v-checkbox></th>
                                                <th><v-select outlined :items="reportColumnSelectItem" v-model="clmn.type"></v-select></th>
                                                <th>
                                                    <div class="d-flex flex-row">
                                                        <v-text-field outlined v-for="s of clmn._selectItems" :key="s.value" v-model="s.text"></v-text-field>
                                                        <v-btn :disabled="clmn.type!=='select'" @click="addSelectItem(clmn._key)">{{text.add}}</v-btn>
                                                    </div>
                                                </th>
                                            </tr>
                                        </tbody>
                                        <thead>
                                            <tr>
                                                <th><v-btn @click="addReportItem">{{text.add}}</v-btn></th>
                                            </tr>
                                        </thead>
                                    </v-simple-table>
                                    <v-btn @click="updateEcConfigColumn">{{text.update}}</v-btn>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-tab-item>
                    <v-tab-item value="users">
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{text.administrator.conifg.exView.title}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    {{text.administrator.conifg.exView.detai}}<br>
                                    <div>
                                        <div class="d-flex flex-row">
                                            <v-select @change="selectExViewUser" :items="exclusionView.userList" :label="text.administrator.conifg.exView.selectUsr" v-model="exclusionView.setUser"></v-select>
                                            <v-text-field v-model="exclusionView.usefilter" @change="setExViewUserList" :label="text.serchCodeName"></v-text-field>
                                        </div>
                                        <v-divider></v-divider>
                                        <div class="d-flex flex-row">
                                            <div>{{text.administrator.conifg.exView.exUser}}</div>
                                            <div class="slist">
                                                <div>{{ text.administrator.conifg.exView.allow }}</div>
                                                <select multiple size="10" v-model="exclusionView.users.allow.select">
                                                    <option v-for="item of exclusionView.users.allow.view" :key="item.key" :value="item.value" :disabled="item.ismine">{{item.text}}</option>
                                                </select>
                                                <span><v-text-field v-model="exclusionView.users.allow.filter" @input="updateExUserListView" :label="text.serchCodeName"></v-text-field></span>
                                            </div>
                                            <div class="slistC"><v-btn @click="moveExUser(1)">→</v-btn><br><v-btn @click="moveExUser(2)">←</v-btn></div>
                                            <div class="slist">
                                                <div>{{ text.administrator.conifg.exView.deny }}</div>
                                                <select multiple size="10" v-model="exclusionView.users.deny.select">
                                                    <option v-for="item of exclusionView.users.deny.view" :key="item.key" :value="item.value">{{item.text}}</option>
                                                </select>
                                                <span><v-text-field v-model="exclusionView.users.deny.filter" @input="updateExUserListView" :label="text.serchCodeName"></v-text-field></span>
                                            </div>
                                        </div>
                                        <v-divider></v-divider>
                                        <div class="d-flex flex-row">
                                            <div>{{text.administrator.conifg.exView.exDep}}</div>
                                            <div class="slist">
                                                <div>{{ text.administrator.conifg.exView.allow }}</div>
                                                <select multiple size="10" v-model="exclusionView.dep.allow.select">
                                                    <option v-for="item of exclusionView.dep.allow.view" :key="item.key" :value="item.value" :disabled="item.ismine">{{item.text}}</option>
                                                </select>
                                                <span><v-text-field v-model="exclusionView.dep.allow.filter" @input="updateExUserListView" :label="text.serchDepName"></v-text-field></span>
                                            </div>
                                            <div class="slistC"><v-btn @click="moveExUser(3)">→</v-btn><br><v-btn @click="moveExUser(4)">←</v-btn></div>
                                            <div class="slist">
                                                <div>{{ text.administrator.conifg.exView.deny }}</div>
                                                <select multiple size="10" v-model="exclusionView.dep.deny.select">
                                                    <option v-for="item of exclusionView.dep.deny.view" :key="item.key" :value="item.value">{{item.text}}</option>
                                                </select>
                                                <span><v-text-field v-model="exclusionView.dep.deny.filter" @input="updateExUserListView" :label="text.serchDepName"></v-text-field></span>
                                            </div>
                                        </div>
                                    </div>
                                    <v-divider></v-divider>
                                    <v-btn @click="updateEcConfigExView" :disabled="disUpdateBtn">{{text.update}}</v-btn>
                                    <v-btn @click="checkEcConfigExView">{{text.administrator.conifg.exView.check}}</v-btn>
                                    <v-btn @click="checkAllUsersViews">{{text.administrator.conifg.exView.allAllowList}}</v-btn>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                                <v-expansion-panel-header>{{text.administrator.useProxyUsers}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-simple-table>
                                        <thead>
                                            <tr>
                                                <th>{{text.userName}}</th>
                                                <th>{{text.administrator.proxyUser}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="userData in useProxyUsers" :key="userData.user">
                                                <td>{{userData.user}}</td>
                                                <td :class="userData.cssclass"><span>{{userData.proxy}}</span></td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{text.administrator.unknowAdressUser}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-simple-table>
                                        <thead>
                                            <tr>
                                                <th>{{text.pCode}}</th>
                                                <th>{{text.userName}}</th>
                                                <th>{{text.depertment}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="userData in unRegUserList" :key="userData.userId">
                                                <td>{{userData.userId}}</td>
                                                <td>{{userData.userName}}</td>
                                                <td>{{userData.depName}}</td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-tab-item>
                    <v-tab-item value="events">
                        <eventListComponent ref="eventListRef" @parentCall="parentCallback" :ecAdmin="ecAdmin" />
                    </v-tab-item>
                    <v-tab-item value="training">
                        <startEventComponent @parentCall="parentCallback" />
                    </v-tab-item>
                    <v-tab-item value="messege">
                        <sendMessegeComponent @parentCall="parentCallback" :mesTemplete="mesTemplete" />
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
        </v-card>
        <v-dialog persistent v-model="digAddUserConf" max-width="500">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    {{text.administrator.listColumn.userId}}:{{addUserInfo.userId}}<br>
                    {{text.administrator.listColumn.userName}}:{{addUserInfo.userName}}<br>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row>
                            {{text.administrator.confAddUser}}
                        </v-row>
                        <v-row>
                            <v-btn @click="addUserExec">{{text.yes}}</v-btn>
                            <v-btn @click="digAddUserConf = false">{{text.no}}</v-btn>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="digAddConditItem" max-width="500">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-form>
                        <v-select :items="areaCodeSelect" v-model="selectAreaCode" :label="text.administrator.area"></v-select>
                        <v-select :items="quakeInSelect" v-model="selectQuakeIndex" :label="text.administrator.maxInt"></v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="addConsitItemExec">{{text.add}}</v-btn>
                    <v-btn @click="digAddConditItem = false">{{text.cancel}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="digAllowViewUserList.dialog" max-width="500">
            <v-card>
                <v-card-title>{{text.administrator.conifg.exView.allowList}}</v-card-title>
                <v-card-text >
                    <v-container style="overflow:scroll">
                    <v-list dense style="max-height:15em">
                        <v-list-item dense v-for="user of digAllowViewUserList.userList" :key="user">
                            {{user}}
                        </v-list-item>
                    </v-list>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="digAllowViewUserList.dialog=false">{{text.close}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../lang";
    let text = new lang(0);
    import {apiRequest} from "../lib/api";
    import {apiResponseData_ecusers,EcAlertConfig,apiResponseData_user} from "../lib/api/api_response_type";
    import exceljs from "exceljs";
    import fileSaver from "file-saver";
    import * as comm from '../common';
    import * as type from '../types';
    interface vueRefForm extends Vue{
        validate:()=>boolean;
    }
    interface vueEventComp extends Vue{
        getEcEvent:()=>void;
    }
    import eventListComponent from './eventList.vue';
    import startEventComponent from './startEvent.vue';
    import sendMessegeComponent from './messegeSend.vue';

    export default Vue.extend({
        components:{
            eventListComponent,
            startEventComponent,
            sendMessegeComponent,
        },
        data: () => ({
            text : text.Text,
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
            addUserId:"",
            userList:[] as apiResponseData_ecusers,
            depList:[] as Array<{code:string,fullname:string,shortname:string}>,
            adminUsers:[] as Array<{userid:string,name:string}>,
            digAddUserConf:false,
            digAddConditItem:false,
            disExcelBtn:false,
            ecAdmin:true,
            addUserInfo:{
                userId:"",
                userName:"",
            },
            ecConfig:{
                "trigerTime":0,
                "quake":[] as Array<{int:string,area:string}>
            },
            ecCondits:{
                quake:[] as Array<{
                    areaCode:string,
                    areaName:string,
                    maxIntStr:string,
                }>
            },
            selectAreaCode:"",
            areaCodeDic:{} as {[code:string]:string},
            areaCodeSelect:[] as Array<{value:string,text:string}>,
            selectQuakeIndex:"",
            quakeInSelect:[] as Array<{value:string,text:string}>,
            useProxyUsers:[] as Array<{user:string,proxy:string,cssclass:string}>,
            unRegUserList:[] as Array<{userId:string,userName:string,depName:string}>,
            reportData:{
                reportHeders:[] as Array<type.Vuetify_data_table_heders>,
                reportColumnFilter:[] as Array<null|Array<string>>,
                reportData:[] as Array<Array<string>>,
            },
            traningMode:{
                lock:true,
                key:"",
                btn:true,
                subject:"",
                messege:"",
                valid:true,
                start:false,
                limit:300,
                rule:(value:string)=> value.length <300 || text.Text.messege.textLengthOver,
            },
            messegeTemplete:{
                subject:"",
                precall:"",
                call:"",
                callProxy:"",
            },
            itemEdit:{
                open:false,
                x:0,
                y:0,
                text:"",
                value:"",
            },
            exclusionView:{
                userList:[] as Array<{value:string,text:string}>,
                originList:{
                    user:[] as Array<string>,
                    dep:[] as Array<string>,
                },
                usefilter:"",
                selUser:null as null|apiResponseData_user,
                setUser:"",
                users:{
                    allow:{
                        list:[] as Array<{value:string,text:string,isEx:boolean,userName:string,userId:string,key:number,ismine:boolean}>,
                        view:[] as Array<{value:string,text:string,isEx:boolean,userName:string,userId:string,key:number,ismine:boolean}>,
                        select:[] as Array<string>,
                        filter:"",
                    },
                    deny:{
                        list:[] as Array<{value:string,text:string,isEx:boolean,userName:string,userId:string,key:number}>,
                        view:[] as Array<{value:string,text:string,isEx:boolean,userName:string,userId:string,key:number}>,
                        select:[] as Array<string>,
                        filter:"",
                    }
                },
                dep:{
                    allow:{
                        list:[] as Array<{value:string,text:string,isEx:boolean,userName:string,userId:string,key:number,ismine:boolean}>,
                        view:[] as Array<{value:string,text:string,isEx:boolean,userName:string,userId:string,key:number,ismine:boolean}>,
                        select:[] as Array<string>,
                        filter:"",
                    },
                    deny:{
                        list:[] as Array<{value:string,text:string,isEx:boolean,userName:string,userId:string,key:number}>,
                        view:[] as Array<{value:string,text:string,isEx:boolean,userName:string,userId:string,key:number}>,
                        select:[] as Array<string>,
                        filter:"",
                    }
                }
            },
            exclusionDep:{
                selectList:[] as Array<{value:string,text:string}>,
                configData:[] as Array<string>,
                userList:[] as Array<{value:string,text:string}>,
                exView:[] as Array<string>,
                setUser:"",
            },
            reportColumnCount:0,
            reportColumnKey:0,
            reportColumnTemplete:[] as Array<type.reportQuColumn&{_key:string,_selectValue:string,_selected:boolean,_selectItems:Array<{value:string|null,text:string}>}>,
            reportColumnSelectItem:[] as Array<{value:string|null,text:string}>,
            lockCloseBtn:false,
            disUpdateBtn:false,
            digAllowViewUserList:{
                dialog:false,
                userList:[] as Array<string>,
            },
            reportitems:"",
            reportitem:"",
            mesTemplete:[] as Array<{name:string,mes:string,id:number}>,
        }),
        mounted(){
            this.api = this.$store.state.apiSaver;
        },
        methods:{
            reset(){
                //@ts-ignore
                Object.assign(this.$data,this.$options.data());
            },
            parentCallback(order:string){
                switch(order){
                    case "pageShow":
                        this.getUserList();
                        this.getEcConfig();
                        this.reportColumnSelectItem = [
                            {"value":"text","text":this.text.columnSelectItem.text},
                            {"value":"select","text":this.text.columnSelectItem.select},
                        ]
                    break;
                    case "reset":
                        this.reset();
                    break;
                    case "tepmleteUpdate":
                        this.getEcMesTemplate();
                    break;
                    default:
                        this.$emit("parentCall",order);
                        break;
                }
            },
            async getUserList(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const userList = await this.api.apiRequest.request.admin.getUserList();
                    comm.LoadingOverlay(this,false);
                    if(userList.statusCode === 200){
                        this.userList = userList.data;
                        this.useProxyUsers = [];
                        this.adminUsers = [];
                        this.unRegUserList = [];
                        this.useProxyUsers = userList.data.filter(v=>{
                            const proxyUser = v.addressDetail.filter(w=>w.type==="proxy");
                            if(proxyUser.length>0){
                                return true;
                            }
                        }).map(v=>{
                            return {
                                "user":`${v.userid}:${v.username}(${v.depname})`,
                                "proxy":v.addressDetail[0].proxySrver?`${v.addressDetail[0].proxySrver.userid}:${v.addressDetail[0].proxySrver.username}(${v.addressDetail[0].proxySrver.depname})`:"-",
                                "cssclass":v.addressDetail[0].proxySrver?.retire?"warnRetireProxy":"",
                            }
                        });
                        for(const userData of userList.data){
                            if(userData.ecAdmin){
                                this.adminUsers.push({
                                    "name":userData.username,
                                    "userid":userData.userid,
                                });
                            }
                            if(!userData.adressReg){
                                this.unRegUserList.push({
                                    "userId":userData.userid,
                                    "userName":userData.username,
                                    "depName":userData.depname?userData.depname:"",
                                });
                            }
                        }
                        this.setExViewUserList();
                    }else if(userList.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            setExViewUserList(){
                this.exclusionView.userList = this.userList.filter(v=>{
                    if(v.userid.includes(this.exclusionView.usefilter) || v.username.includes(this.exclusionView.usefilter)){
                        return true
                    }
                }).map(v=>{
                    return {"text":`${v.username}(${v.depname||""})`,"value":v.userid}
                });
                if(!this.exclusionView.selUser){
                    return;
                }
                this.updateExUserListView();
            },
            updateExUserListView(){
                let cnt = 0;
                this.exclusionView.users.allow.list = [
                    ...this.userList.filter(v=>{
                        if(v.empcode && this.exclusionView.originList.user.includes(v.empcode)){
                            if(!this.exclusionView.selUser?.exView?.forbid.includes(`u${v.empcode}`)){
                                return true;
                            }
                        }
                    }).map(v=>{
                        return {"text":`${v.username}(${v.depname||""})`,"value":v.userid,"isEx":false,"userId":v.userid,"userName":v.username,"key":cnt++,"ismine":this.exclusionView.selUser?.userid===v.userid?true:false}
                    }),
                    ...this.userList.filter(v=>{
                        if(v.empcode && this.exclusionView.selUser?.exView?.allow.includes(`u${v.empcode}`)){
                            return true;
                        }
                    }).map(v=>{
                        return {"text":`*${v.username}(${v.depname||""})`,"value":v.userid,"isEx":false,"userId":v.userid,"userName":v.username,"key":cnt++,"ismine":false}
                    }),
                ];
                this.exclusionView.users.allow.view = this.exclusionView.users.allow.list.filter(v=>{
                    if(v.userId.includes(this.exclusionView.users.allow.filter) || v.userName.includes(this.exclusionView.users.allow.filter)){
                        return true;
                    }
                }).sort((a,b)=>{
                    if(a.ismine){
                        return -1;
                    }else if(b.ismine){
                        return 1;
                    }
                    return a.userId.localeCompare(b.userId);
                });
                this.exclusionView.users.deny.list = [
                    ...this.userList.filter(v=>{
                        if(!this.exclusionView.originList.user.includes(v.empcode)){
                            if(this.exclusionView.selUser?.exView?.allow.includes(`u${v.empcode}`)){
                                return false;
                            }
                            return true;
                        }
                    }).map(v=>{
                        return {"text":`${v.username}(${v.depname||""})`,"value":v.userid,"isEx":false,"userId":v.userid,"userName":v.username,"key":cnt++}
                    }),
                    ...this.userList.filter(v=>{
                        if(v.empcode && this.exclusionView.selUser?.exView){
                            if(this.exclusionView.selUser.exView.forbid.includes(`u${v.empcode}`)){
                                return true;
                            }
                        }
                        return false
                    }).map(v=>{
                        return {"text":`*${v.username}(${v.depname||""})`,"value":v.userid,"isEx":false,"userId":v.userid,"userName":v.username,"key":cnt++}
                    }),
                ];
                this.exclusionView.users.deny.view = this.exclusionView.users.deny.list.filter(v=>{
                    if(v.userId.includes(this.exclusionView.users.deny.filter) || v.userName.includes(this.exclusionView.users.deny.filter)){
                        return true;
                    }
                }).sort((a,b)=>{
                    return a.userId.localeCompare(b.userId);
                });
                this.exclusionView.dep.allow.list = [
                    ...this.depList.filter(v=>{
                        if(this.exclusionView.originList.dep.includes(v.code)){
                            if(!this.exclusionView.selUser?.exView?.forbid.includes(`d${v.code}`)){
                                return true;
                            }
                        }
                    }).map(v=>{
                        return {"text":`${v.fullname}`,"value":v.code,"isEx":false,"userId":v.code,"userName":v.fullname,"key":cnt++,"ismine":false}
                    }),
                    ...this.depList.filter(v=>{
                        if(!this.exclusionView.originList.dep.includes(v.code)){
                            if(this.exclusionView.selUser?.exView?.allow.includes(`d${v.code}`)){
                                return true;
                            }
                        }
                    }).map(v=>{
                        return {"text":`*${v.fullname}`,"value":v.code,"isEx":false,"userId":v.code,"userName":v.fullname,"key":cnt++,"ismine":false}
                    }),
                ]
                this.exclusionView.dep.allow.view = this.exclusionView.dep.allow.list.filter(v=>{
                    if(v.userId.includes(this.exclusionView.dep.allow.filter) || v.userName.includes(this.exclusionView.dep.allow.filter)){
                        return true;
                    }
                }).sort((a,b)=>{
                    return a.userId.localeCompare(b.userId);
                });
                this.exclusionView.dep.deny.list = [
                    ...this.depList.filter(v=>{
                        if(!this.exclusionView.originList.dep.includes(v.code)){
                            if(this.exclusionView.selUser?.exView?.allow.includes(`d${v.code}`)){
                                return false;
                            }
                            return true;
                        }
                    }).map(v=>{
                        return {"text":`${v.fullname}`,"value":v.code,"isEx":false,"userId":v.code,"userName":v.fullname,"key":cnt++,"ismine":false}
                    }),
                    ...this.depList.filter(v=>{
                        if(this.exclusionView.originList.dep.includes(v.code)){
                            if(this.exclusionView.selUser?.exView?.forbid.includes(`d${v.code}`)){
                                return true;
                            }
                        }
                    }).map(v=>{
                        return {"text":`*${v.fullname}`,"value":v.code,"isEx":false,"userId":v.code,"userName":v.fullname,"key":cnt++,"ismine":false}
                    }),
                ]
                this.exclusionView.dep.deny.view = this.exclusionView.dep.deny.list.filter(v=>{
                    if(v.userId.includes(this.exclusionView.dep.deny.filter) || v.userName.includes(this.exclusionView.dep.deny.filter)){
                        return true;
                    }
                }).sort((a,b)=>{
                    return a.userId.localeCompare(b.userId);
                });
            },
            moveExUser(mode:1|2|3|4){
                if(!this.exclusionView.selUser){
                    return;
                }
                if(mode === 1){
                    //Allow to Deny
                    for(const moveId of this.exclusionView.users.allow.select){
                        const moveUser = this.userList.find(v=>{
                            if(v.userid === moveId){
                                return true;
                            }
                        });
                        if(!moveUser){
                            return;
                        }
                        if(this.exclusionView.selUser.exView?.allow.includes(`u${moveUser.empcode}`)){
                            //追加だったら、追加リストから削除
                            this.exclusionView.selUser.exView.allow = this.exclusionView.selUser.exView.allow.filter(v=>{
                                if(v !== `u${moveUser.empcode}`){
                                    return true;
                                }
                            })
                        }else{
                            if(this.exclusionView.selUser.exView){
                                this.exclusionView.selUser.exView.forbid.push(`u${moveUser.empcode}`);
                            }else{
                                this.exclusionView.selUser.exView = {
                                    "allow":[],
                                    "forbid":[`u${moveUser.empcode}`]
                                }
                            }
                        }
                    }
                }else if(mode === 2){
                    //Deby to Allow
                    for(const moveId of this.exclusionView.users.deny.select){
                        const moveUser = this.userList.find(v=>{
                            if(v.userid === moveId){
                                return true;
                            }
                        });
                        if(!moveUser){
                            return;
                        }
                        if(this.exclusionView.selUser.exView?.forbid.includes(`u${moveUser.empcode}`)){
                            //追加だったら、追加リストから削除
                            this.exclusionView.selUser.exView.forbid = this.exclusionView.selUser.exView.forbid.filter(v=>{
                                if(v !== `u${moveUser.empcode}`){
                                    return true;
                                }
                            })
                        }else{
                            if(this.exclusionView.selUser.exView){
                                this.exclusionView.selUser.exView.allow.push(`u${moveUser.empcode}`);
                            }else{
                                this.exclusionView.selUser.exView = {
                                    "allow":[`u${moveUser.empcode}`],
                                    "forbid":[],
                                }
                            }
                        }
                    }
                }else if(mode === 3){
                    //Allow to Deny
                    for(const moveId of this.exclusionView.dep.allow.select){
                        const moveUser = this.depList.find(v=>{
                            if(v.code === moveId){
                                return true;
                            }
                        });
                        if(!moveUser){
                            return;
                        }
                        if(this.exclusionView.selUser.exView?.allow.includes(`d${moveUser.code}`)){
                            //追加だったら、追加リストから削除
                            this.exclusionView.selUser.exView.allow = this.exclusionView.selUser.exView.allow.filter(v=>{
                                if(v !== `d${moveUser.code}`){
                                    return true;
                                }
                            })
                        }else{
                            if(this.exclusionView.selUser.exView){
                                this.exclusionView.selUser.exView.forbid.push(`d${moveUser.code}`);
                            }else{
                                this.exclusionView.selUser.exView = {
                                    "allow":[],
                                    "forbid":[`d${moveUser.code}`]
                                }
                            }
                        }
                    }
                }else if(mode === 4){
                    //Deby to Allow
                    for(const moveId of this.exclusionView.dep.deny.select){
                        const moveUser = this.depList.find(v=>{
                            if(v.code === moveId){
                                return true;
                            }
                        });
                        if(!moveUser){
                            return;
                        }
                        if(this.exclusionView.selUser.exView?.forbid.includes(`d${moveUser.code}`)){
                            //追加だったら、追加リストから削除
                            this.exclusionView.selUser.exView.forbid = this.exclusionView.selUser.exView.forbid.filter(v=>{
                                if(v !== `d${moveUser.code}`){
                                    return true;
                                }
                            })
                        }else{
                            if(this.exclusionView.selUser.exView){
                                this.exclusionView.selUser.exView.allow.push(`d${moveUser.code}`);
                            }else{
                                this.exclusionView.selUser.exView = {
                                    "allow":[`d${moveUser.code}`],
                                    "forbid":[],
                                }
                            }
                        }
                    }
                }
                this.updateExUserListView();
            },
            addAdminUser(){
                this.addUserInfo = {"userId":"","userName":""};
                for(const userData of  this.userList){
                    if(userData.userid === this.addUserId){
                        this.addUserInfo = {
                            "userId":userData.userid,
                            "userName":userData.username,
                        }
                    }
                }
                if(this.addUserInfo.userId.length > 0){
                    this.digAddUserConf = true;
                }else{
                    comm.WaringMessege(this,text.Text.messege.unknowUser);
                }
            },
            async addUserExec(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const response = await this.api.apiRequest.request.admin.setEcAdminUser(this.addUserInfo.userId);
                    comm.LoadingOverlay(this,false);
                    if(response.statusCode === 200){
                        this.digAddUserConf = false;
                        this.getUserList();
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                    }else if(response.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            async removeUser(userid:string){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const response = await this.api.apiRequest.request.admin.unsetEcAdminUser(userid);
                    comm.LoadingOverlay(this,false);
                    if(response.statusCode === 200){
                        this.digAddUserConf = false;
                        this.getUserList();
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                    }else if(response.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            async getEcConfig(){
                this.quakeInSelect = [];
                for(const [k,v] of Object.entries(this.text.quakeIndex)){
                    this.quakeInSelect.push({
                        "text":v,
                        "value":k,
                    });
                    this.quakeInSelect.sort((a,b)=>{
                        return comm.quakeLevelSort(a,b);
                    })
                }
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const ecConfig = await this.api.apiRequest.request.admin.getEcConfig();
                    comm.LoadingOverlay(this,false);
                    if(ecConfig.statusCode === 200){
                        this.areaCodeSelect = [];
                        this.areaCodeDic = {};
                        const jmaCode = ecConfig.data.jmaArea;
                        for(const codeDetail of jmaCode){
                            this.areaCodeSelect.push({
                                "value":codeDetail.ACODE,
                                "text":`${codeDetail.ACODE}:${codeDetail.ANAME}`,
                            });
                            this.areaCodeSelect.sort((a,b)=>{
                                return comm.areaCodeSort(a,b);
                            });
                            this.areaCodeDic[codeDetail.ACODE] = codeDetail.ANAME;
                        }
                        const ecConfigData = ecConfig.data;
                        this.ecConfig = {
                            "trigerTime":ecConfigData.ecAlert.conifg.trigerTime,
                            "quake":ecConfigData.ecAlert.conifg.condition.quake,
                        }
                        this.ecCondits.quake = [];
                        for(const quakeCondits of this.ecConfig.quake){
                            this.ecCondits.quake.push({
                                "areaCode":quakeCondits.area,
                                "areaName":this.areaCodeDic[quakeCondits.area],
                                "maxIntStr":this.text.quakeIndex[quakeCondits.int],
                            })
                        }
                        this.messegeTemplete.subject = ecConfigData.messege.EC_MessegeTitle;
                        this.messegeTemplete.precall = ecConfigData.messege.EC_Messege_Precall;
                        this.messegeTemplete.call = ecConfigData.messege.EC_Messege_Call;
                        this.messegeTemplete.callProxy = ecConfigData.messege.EC_Messege_Proxy;
                        this.reportColumnTemplete = ecConfigData.reportColumn.map(v=>Object.assign(v,{_key:"",_selectValue:"",_selected:false,_selectItems:[]}));
                        this.reportColumnCount = 0;
                        this.reportColumnKey = 0;
                        this.reportColumnTemplete = this.reportColumnTemplete.map(v=>{
                            v._selectValue = "";
                            this.reportColumnKey++;
                            v._key = `_${this.reportColumnKey.toString()}`;
                            if(v.type === "select"){
                                v._selected = true;
                                if(v.selectItem){
                                    v._selectItems = v.selectItem.map(item=>{
                                        this.reportColumnCount++;
                                        return {"text":item,"value":`_${this.reportColumnCount.toString()}`}
                                    });
                                }else{
                                    v._selectItems = [];
                                }
                            }else{
                                v._selected = false;
                                v._selectItems = [];
                            }
                            this.reportColumnCount++;
                            return v;
                        });
                        this.exclusionDep.configData = ecConfigData.ecMessegeExclusion;
                        this.depList = ecConfigData.depertmentList.filter(v=>{
                            if(v.code === "00" || v.code === "009999    "){
                                return false;
                            }
                            return true;
                        });
                        this.exclusionDep.selectList = ecConfigData.depertmentList.map(v=>{
                            return {"text":v.fullname,"value":v.code}
                        });
                    }else if(ecConfig.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            addReportItem(){
                this.reportColumnKey++
                this.reportColumnTemplete.push({
                    "type":"text",
                    "title":"",
                    "_key":`_${this.reportColumnKey.toString()}`,
                    "required":false,
                    "_selectValue":"",
                    "_selected":false,
                    "_selectItems":[]
                    });
            },
            addConsitItem(){
                this.digAddConditItem = true;
            },
            addConsitItemExec(){
                this.ecConfig.quake.push({
                    "area":this.selectAreaCode,
                    "int":this.selectQuakeIndex
                });
                //Fix
                this._updateecEcAlert(1,this.ecConfig.quake);
            },
            addSelectItem(keyNo:string){
                for(const item of this.reportColumnTemplete){
                    if(item._key == keyNo){
                        this.reportColumnCount++;
                        item._selectItems.push({"text":"","value":`_${this.reportColumnCount}`});
                    }
                }
                this.reportColumnTemplete.splice(this.reportColumnTemplete.length);
            },
            updateEcConfigTime(){
                this._updateecEcConfig("AlertCancelInterval",parseInt(this.ecConfig.trigerTime.toString(),10));
            },
            updateEcConfigCondtItem(type:number,code:string){
                switch (type){
                    case 1:{
                        const cloneEcCoOnfig = Object.assign({},this.ecConfig);
                        this.ecConfig.quake = [];
                        for(const quakeCondits of cloneEcCoOnfig.quake){
                            if(quakeCondits.area !== code){
                                this.ecConfig.quake.push(quakeCondits);
                            }
                        }
                        this._updateecEcAlert(1,this.ecConfig.quake)
                    }
                    break;
                }
            },
            updateEcConfigMessege(){
                    this._updateecEcConfig("MESSEGE",{
                        "EC_MessegeTitle":this.messegeTemplete.subject,
                        "EC_Messege_Precall":this.messegeTemplete.precall,
                        "EC_Messege_Call":this.messegeTemplete.call,
                        "EC_Messege_Proxy":this.messegeTemplete.callProxy,
                    });
                },
            updateEcConfigColumn(){
                    const updateColomn = [] as Array<type.reportQuColumn>;
                    this.reportColumnTemplete = this.reportColumnTemplete.filter(v=>v.title);
                    for(const item of this.reportColumnTemplete){
                        if(item.title.length === 0){break}
                        if(item.type === "select"){
                            item._selectItems = item._selectItems.filter(v=>{
                                if(v.text.length>0){return true}else{return false}
                            });
                            if(item._selectItems.length === 0){break}
                        }
                        updateColomn.push({
                            "title":item.title,
                            "type":item.type,
                            "required":item.required,
                            "selectItem":item.type==='select'?item._selectItems.map(v=>{return v.text}):undefined
                        });
                    }
                    this._updateecEcConfig("ReportColumn",{"reportColumn":updateColomn});
            },
            updateEcConfigDep(){
                this._updateecEcConfig("MessegeExclusion",this.exclusionDep.configData);
            },
            async _updateecEcConfig(configName:string,val:any){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    this.disUpdateBtn = true;
                    const response = await this.api.apiRequest.request.admin.putEcConfig(configName,val);
                    comm.LoadingOverlay(this,false);
                    this.disUpdateBtn = false;
                    if(response.statusCode === 200){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        this.getEcConfig();
                    }else if(response.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            async _updateecEcAlert(type:number,data:Array<{int:string,area:string}>){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    this.disUpdateBtn = true;
                    const setData:Array<EcAlertConfig> = [];
                    if(type === 1){
                        for(const quakeCondt of data){
                            setData.push({
                                "area":quakeCondt.area,
                                "condition":{
                                    "maxInt":quakeCondt.int
                                }
                            });
                        }
                    }
                    const response = await this.api.apiRequest.request.admin.putEcAlert(type,setData);
                    comm.LoadingOverlay(this,false);
                    this.disUpdateBtn = false;
                    if(response.statusCode === 200){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        this.getEcConfig();
                    }else if(response.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            exportExcel(){
                this.disExcelBtn = true;
                this.exportExcelSave();
            },
            async exportExcelSave(){
                const workBook = new exceljs.Workbook();
                const sheet = workBook.addWorksheet();
                comm.exceljsUtils.setRow(sheet,{row:1,column:1},this.reportData.reportHeders.map(v=>v.text));
                let row = 2;
                for(const item of this.reportData.reportData){
                    comm.exceljsUtils.setRow(sheet,{"row":row,"column":1},item);
                    row++;
                }
                const _wbBuffer = await workBook.xlsx.writeBuffer();
                fileSaver.saveAs(new Blob([_wbBuffer]),"report.xlsx");
                this.disExcelBtn = false;
            },
            async selectExViewUser(){
                const selUset = this.userList.filter(v=>{
                    if(v.userid === this.exclusionView.setUser){return true}else{return false}});
                if(!selUset[0].empcode){
                    return;
                }
                this.exclusionView.selUser = selUset[0];
                this.setExViewUserList();
            },
            async updateEcConfigExView(){
                if(this.exclusionView.selUser && this.exclusionView.selUser?.exView){
                    if(this.api && this.api.connection && this.api.apiRequest){
                        this.disUpdateBtn = true;
                        comm.LoadingOverlay(this,true);
                        const response = await this.api.apiRequest.request.admin.updateAllowViewUsers(this.exclusionView.selUser.userid,this.exclusionView.selUser.exView)
                        comm.LoadingOverlay(this,false);
                        this.disUpdateBtn = false;
                        if(response.statusCode === 200){
                            comm.SuccessMessege(this,this.text.messege.dbSccess);
                            this.getUserList();
                        }else if(response.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError,true);
                        }
                    }
                }
            },
            async checkEcConfigExView(){
                if(!this.exclusionView.selUser){
                    return;
                }
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    this.digAllowViewUserList.dialog = false;
                    this.digAllowViewUserList.userList = [];
                    const response = await this.api.apiRequest.request.admin.getAllowViewUsers(this.exclusionView.selUser.userid,this.exclusionView.selUser?.exView||undefined)
                    comm.LoadingOverlay(this,false);
                    this.disUpdateBtn = false;
                    if(response.statusCode === 200){
                        for(const allowUser of response.data.userlist){
                                const userData =this.userList.filter(v=>{
                                        if(v.empcode === allowUser){return true}else{return false}
                                    })[0];
                                if(userData){
                                    this.digAllowViewUserList.userList.push(`${userData.username}(${userData.depname})`);
                                }
                            }
                            this.digAllowViewUserList.dialog = true;
                    }else if(response.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            async checkAllUsersViews(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    const allowsLists = [] as Array<{user:string,view:string}>;
                    comm.LoadingOverlay(this,true);
                    this.digAllowViewUserList.dialog = false;
                    this.digAllowViewUserList.userList = [];
                    const response = await this.api.apiRequest.request.admin.getAllListOfAllowViewUsers();
                    comm.LoadingOverlay(this,false);
                    this.disUpdateBtn = false;
                    if(response.statusCode === 200){
                        for(const allowUser of response.data){
                                const userData =this.userList.filter(v=>{
                                        if(v.userid === allowUser.user){return true}else{return false}
                                    })[0];
                                if(userData){
                                    this.digAllowViewUserList.userList.push(`${userData.username}(${userData.depname})`);
                                }
                            }
                            this.digAllowViewUserList.dialog = true;
                    }else if(response.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                    if(allowsLists.length > 0){
                        const workBook = new exceljs.Workbook();
                        const sheet = workBook.addWorksheet();
                        comm.exceljsUtils.setRow(sheet,{row:1,column:1},["ユーザー","閲覧対象"]);
                        let row = 2;
                        for(const item of allowsLists){
                            comm.exceljsUtils.setRow(sheet,{"row":row,"column":1},[item.user,item.view]);
                            row++;
                        }
                        const _wbBuffer = await workBook.xlsx.writeBuffer();
                        fileSaver.saveAs(new Blob([_wbBuffer]),"report.xlsx");
                    }
                }
            },
            getEcEvent(){
                const eventDetail = this.$refs.eventListRef as vueEventComp;
                if(eventDetail){
                    eventDetail.getEcEvent(); 
                }else{
                    setTimeout(this.getEcEvent,10);
                }
            },
            async getEcMesTemplate(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    const response = await this.api.apiRequest.request.admin.getMesTepmlete();
                    console.log(response);
                    comm.LoadingOverlay(this,false);
                    this.disUpdateBtn = false;
                    if(response.statusCode === 200){
                        this.mesTemplete.splice(0);
                        for(const tepmlate of response.data.sort((a,b)=>a.id-b.id)){
                            this.mesTemplete.push({
                                "id":tepmlate.id,
                                "mes":tepmlate.text,
                                "name":tepmlate.name,
                            });
                        }
                    }else if(response.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            }
        }
    });
</script>
<style>
.hoverPointer:hover{
    cursor: pointer;
}
.warnRetireProxy{
    background-color: orange;
}
.warnRetireProxy > span{
    font-weight: bold;
}
div.slist {
    width: 40%;
}
div.slist > select{
    width: 100%;
    border-style: solid;
}
div.slistC{
    margin: auto 1em;
}
</style>